import { Commit as CommitIcon, Build as BuildIcon } from '@mui/icons-material';
import { Box, Typography, Chip, Tooltip, IconButton } from '@mui/material';
import React, { useState, useEffect } from 'react';

interface BuildInfo {
  commitHash: string;
  shortHash: string;
  branch: string;
  buildTime: string;
  deploymentId: string;
}

const DeploymentIndicator: React.FC = () => {
  const [buildInfo, setBuildInfo] = useState<BuildInfo | null>(null);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const fetchBuildInfo = async () => {
      try {
        const response = await fetch('/api/health/build-info');
        if (response.ok) {
          const data = await response.json();
          if (data.status === 'success') {
            setBuildInfo(data.data);
          }
        }
      } catch (error) {
        console.warn('[DeploymentIndicator] Failed to fetch build info:', error);
      }
    };

    fetchBuildInfo();
  }, []);

  if (!buildInfo) {
    return null; // Don't show anything if we can't fetch build info
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 16,
        right: 16,
        zIndex: 1000,
        maxWidth: 300
      }}
    >
      <Tooltip
        title={
          <Box>
            <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1 }}>
              Deployment Information
            </Typography>
            <Typography variant="caption" component="div">
              Commit: {buildInfo.shortHash}
            </Typography>
            <Typography variant="caption" component="div">
              Branch: {buildInfo.branch}
            </Typography>
            <Typography variant="caption" component="div">
              Built: {new Date(buildInfo.buildTime).toLocaleString()}
            </Typography>
            <Typography variant="caption" component="div">
              ID: {buildInfo.deploymentId}
            </Typography>
          </Box>
        }
        arrow
        placement="top"
      >
        <Chip
          icon={<BuildIcon />}
          label={`${buildInfo.shortHash} (${buildInfo.branch})`}
          size="small"
          variant="outlined"
          sx={{
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(0, 0, 0, 0.12)',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 1)',
            }
          }}
          onClick={() => setShowDetails(!showDetails)}
        />
      </Tooltip>
    </Box>
  );
};

export default DeploymentIndicator;